export const MODAL_NAMES = {
  RESET_PASSWORD_EXPLANATION: 'RESET_PASSWORD_EXPLANATION',
}

export const VALID_PASSWORD_REGEXP = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).+$/

export const VALIDATION_ERROR = '/errors/validation-error'
